import { render, staticRenderFns } from "./gearposition.vue?vue&type=template&id=236b8963&scoped=true&"
import script from "./gearposition.vue?vue&type=script&lang=js&"
export * from "./gearposition.vue?vue&type=script&lang=js&"
import style0 from "./gearposition.vue?vue&type=style&index=0&id=236b8963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b8963",
  null
  
)

export default component.exports